exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html[data-v-3046a084]{height:100%}body[data-v-3046a084]{font-family:Lato,sans-serif;color:#888;margin:0}.error[data-v-3046a084]{text-align:center}", ""]);

// exports
